<template>
  <v-app id="inspire">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout=6000>
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <eps-sidebar :drawer="$store.state.drawer"></eps-sidebar>
    <eps-header :drawer="$store.state.drawer"></eps-header>
    
     <v-content>
      <v-container fluid> 
<!-- <div>Quick-Links Home
        <router-link :to="{name:'employee-type'}">click</router-link>
      </div>       --> 
     <!-- <span v-if="usertype == 'Parent' || usertype == 'Student'"> -->
      <!--<span v-if="usertype == 'Parent'">
        <span v-if="get_outstanding_details == true"> 
        <v-row dense justify="center">
            <v-col class="text-center" cols="12" sm="12" md="12" >
            <v-alert type="error" class="image-responsive flash">
             You have got some Outstanding fees Pending please Pay via Account & Fees Module.
            </v-alert>
            </v-col>
             </v-row>
            </span>
      </span> -->
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import epsSidebar from "../shared/Sidebar";
import epsHeader from "../shared/UpdatedHeader.vue";

import axios from "axios";
export default {
  data: () => ({
    dialog: false,
    drawer: null,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    get_outstanding_details:null,
    usertype:null,
    report_fields:null
  }),
  components: {
    epsSidebar: epsSidebar,
    epsHeader: epsHeader,
   
  },
 mounted() {
    this.initcall();
    // this.report_fields = JSON.parse(localStorage.getItem("report-field"))
    // console.log('logo1', this.report_fields.logo1)
    // console.log('report', this.report_fields)

    localStorage.setItem("all-links",null)
  },
   methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    initcall(){
      axios
        .get("/home/getParentFees")
        .then(res => {
          this.get_outstanding_details = res.data.get_outstanding_details
          this.usertype = res.data.usertype
        })
        .catch(error => {})
        .finally(() => {
          
        });
    }
   }
};
</script>


<style scoped>
.image-responsive{
    margin-top: 20%;
    margin-bottom: 50%;
    margin-left: 10%;
    margin-right: 10%;
}
.flash {
   animation-name: flash;
    animation-duration: 0.9s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-play-state: running;
}

@keyframes flash {
    from {color: red;}
    to {color: white;}
}
</style>